import { App } from '@capacitor/app'
import { useEffect, useState } from 'react'

import type { RestoredListenerEvent, URLOpenListenerEvent } from '@capacitor/app'

export const useAppState = () => {
  const [active, setActive] = useState<boolean>(true)
  const [urlTrigger, setUrlTrigger] = useState<URLOpenListenerEvent>()
  const [restoredData, setRestoredData] = useState<RestoredListenerEvent>()

  useEffect(() => {
    const listeners: Promise<any>[] = []

    listeners.push(
      App.addListener('appStateChange', ({ isActive }) => {
        setActive(isActive)
      }),
      App.addListener('appUrlOpen', (data) => {
        setUrlTrigger(data)
      }),
      App.addListener('appRestoredResult', (data) => {
        setRestoredData(data)
      }),
    )

    return () => {
      listeners.forEach((listener) => {
        listener.then((handle) => handle.remove())
      })
    }
  }, [])

  return {
    active,
    urlTrigger,
    restoredData,
  }
}
